import { render, staticRenderFns } from "./LogManage.vue?vue&type=template&id=2b1c56a3&scoped=true&"
import script from "./LogManage.vue?vue&type=script&lang=js&"
export * from "./LogManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c56a3",
  null
  
)

export default component.exports